<template>
  <div class="scroll-container">
    <div class="main" >
      <div class="content-wrapper">
        <div class="content" :class="{ 'final-page-content': pageNumber === 7 }">
            <Header v-if="pageNumber !== 1"/>
            <LandingPage v-if="pageNumber === 1"/>
            <AboutYou v-if="pageNumber === 2"/>
            <Mortgages v-if="pageNumber === 3"/>
            <Overheads v-if="pageNumber === 4"/>
            <Summary v-if="pageNumber === 5"/>
            <Calculator v-if="pageNumber === 6"/>
            <FinalSummary v-if="pageNumber === 7"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import LandingPage from './components/LandingPage.vue'
import AboutYou from './components/AboutYou.vue'
import Mortgages from './components/Mortgages.vue'
import Overheads from './components/Overheads.vue'
import Summary from './components/IncomeSummary.vue'
import Calculator from './components/Calculator.vue'
import FinalSummary from './components/FinalSummary.vue'

export default {
  name: 'App',
  //data: function(){
  //  return {
  //  }
  //},
  computed: {
    pageNumber(){
      return this.$store.state.pageNum
    }
  },
  components: {
    Header,
    LandingPage,
    AboutYou,
    Mortgages,
    Overheads,
    Summary,
    Calculator,
    FinalSummary
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
